module.exports = __webpack_public_path__ + "static/img/14.957c204.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/eng/14.png
// module id = Fizu
// module chunks = 0